const inspirator = {
    penilaianResumeInspirator: {
        icon: 'file-done',
        text: 'Penilaian Resume',
        route: 'admin.classical.files.resume',
        role: {
            classical: [ 'inspirator' ],
        }
    },
}

export default inspirator
